import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import moment from "moment";
import Board from "./Board";
import { TaskContext, ColumnContext, PermissionContext } from "../context";
import { DragDropContext, Droppable } from "@hello-pangea/dnd";
import { v4 as uuid } from "uuid";
import services from "../services";
import Header from "../components/Header";
import InboxData from "../components/Inbox/InboxData";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { socket, gmailSocket } from "../socket";
import LabelIcon from "@mui/icons-material/Label";
import { CreateLabelDialog } from "../common/CreateLabelDialog";
import DeleteLabelDialog from "../common/DeleteLabelDialog";
import {
  boardLocal,
  columnsLocal,
  tasksLocal,
  userDataLocal,
} from "../utils/LocalSt";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import WhatsappData from "../components/Inbox/WhatsappData";
import WhatsAppAuth from "./WhatsAuthUser";
import EmailAuth from "./EmailAuthUser";
import SearchBar from "material-ui-search-bar";
import {
  addColumnsDetails,
  setEmailStatus,
  setWhatsAppStatus,
} from "../Redux/slice";
import { MultiSelect } from "react-multi-select-component";
import { getAllDateTableTask, getTaskMail } from "../Redux/GetSlice";
import { use } from "react";
import Loading from "../utils/Loading";
import { dataMerger } from "../utils/dataMerger";
import { PrivilegesChecker } from "../utils/PrivilegesChecker";
import Select from "react-select";
import {
  getLocalStorageItem,
  removeLocalStorageItem,
  setLocalStorageItem,
} from "../utils/Localstorage/localStorageUtils";
import { Collapse, IconButton } from "@mui/material";
import { ExpandMore, ChevronRight, Folder, Check } from "@mui/icons-material";

import labelService from "../services/labelService";
import board from "../services/board";
import task from "../services/task";

import MoreVert from '@mui/icons-material/MoreVert';
import Edit from '@mui/icons-material/Edit';
import Delete from '@mui/icons-material/Delete';
import ResponsivePagination from "react-responsive-pagination";
import user from "../api/user";
import AddContactModal from "./Whatsapp/AddContactModal";
import ChatWhatsapp from "./Whatsapp/ChatWhatsapp";
import ShowAllMail from "./AllMail/";


const AppViewer = ({ showGmailTab, showWhatsappTab, userRole, parentOrigin }) => {
  const location = useLocation()
  const tasksInMemory = tasksLocal() || [];
  const [tasks, setTasks] = useState(tasksInMemory);
  const [taskList, setTaskList] = useState([]);
  const [originalTaskList, setOriginalTaskList] = useState([]);
  const [filterList, setFilterList] = useState();
  const [menuOpenId, setMenuOpenId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pagination, setPagination] = useState({});
  const [selectedLabelId, setSelectedLabelId] = useState(null);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deleteLabelId, setDeleteLabelId] = useState(null);
  const limit = 10;
  const [selectedBoardId, setSelectedBoardId] = useState("");
  const [openLabelDialog, setOpenLabelDialog] = useState(false);
  const [selecteType, setSelecteType] = useState("");
  const [taskPagination, setTaskPagination] = useState({
    currentPage: 1,
    totalPages: 1,
  });
  const [sessionId, setSessionId] = useState(null);

  const [lastExpandedId, setLastExpandedId] = useState(
    () => sessionStorage.getItem('lastExpandedLabelId') || null
  );

  const listRef = useRef(null);
  const [taskCurrentPage, setTaskCurrentPage] = useState(1);
  const [filters, setFilters] = useState([
    { field: "", operator: "", value: "" },
  ]);
  const [emails, setEmails] = useState([]);
  const [sentEmails, setSentEmails] = useState([])
  const [mailPage, setMailPage] = useState(1)
  const [totalCount, setTotalCount] = useState(0)
  const labelID = location?.state?.labelID
  const [node, setNode] = useState({});
  const [columnAutomation, setColumnAutomation] = useState([]);
  const [allCustomFieldList, setAllCustomFieldList] = useState([]);
  const [userList, setUserList] = useState([]); // This will be board users
  const [allUsers, setAllUsers] = useState([]); // This will be all system users
  const [showAddContactModal, setShowAddContactModal] = useState(false)
  const abortControllerRef = useRef(null);
  const requestIdRef = useRef(0);

  async function fetchAllEmailById(id) {
    try {
      const res = await labelService.GET_Label_By_Id(id);
    } catch (error) {
      console.error("Error fetching all labels:", error);
    }
  }
  const handleContactAdded = async (newContact) => {
    try {
      if (selectedProfileId) {
        let matchedContact = null;
        let attempts = 0;
        while (!matchedContact && attempts < 5) {
          const response = await services.Whatsapp.GET_BYID_WHATSAPP_PROFILE(
            selectedProfileId
          );

          const allFreshContacts = response?.data?.data?.Contacts || [];
          setAllWhatsappData(allFreshContacts)


          matchedContact = allFreshContacts.find((item) =>


            item?.contactNo?.includes(newContact.value)
          );


          attempts++;
          await new Promise((resolve) => setTimeout(resolve, 1000));
        }

        if (!matchedContact) {
        }
        setSearched('')
      }
    } catch (error) {
      console.error("Error handling contact addition:", error);
      toast.error("Failed to add contact to selection. Please try again.");
    } finally {
    }
  };

  function handleEditLabel(id) {
    setSelectedLabelId(id);
    setOpenLabelDialog(true);
  }

  function handleDeleteLabel(id) {
    setDeleteLabelId(id);
    setOpenDeleteDialog(true);

  }

  const fetchAllData = async () => {
    try {

      const [boardRes, labelRes] = await Promise.all([
        board.GET_BOARD_LIST(),
        labelService.GET_Label_ALL(),
      ]);

      const boards = boardRes.data?.data || [];
      const labels = labelRes.data?.labels || [];

      const treeData = {
        id: "root",
        label: "Root",
        expanded: true,
        selected: false,
        children: [
          {
            id: "kanban-root",
            label: "Kanban",
            type: "kanban-root",
            expanded: false,
            selected: false,
            children: transformBoardsToTree(boards),
          },
          {
            id: "label-root",
            label: "Labels",
            type: "label-root",
            expanded: false,
            selected: false,
            children: transformLabelsToTree(labels),
          },
        ],
      };


      setNode(treeData);
      const navStateLast = (location && location.state && location.state.lastExpandedId) || null;
      const stored = sessionStorage.getItem('lastExpandedLabelId');

      const idToRestore = navStateLast || stored || lastExpandedId;
      if (idToRestore) {
        expandPathToId(idToRestore);
        setTimeout(() => {
          selectNode(idToRestore);
        }, 0);
      }
    } catch (error) {
      console.error("Error fetching boards or labels:", error);
    }
  };


  async function fetchSentEmails(page = 1, limit = 10) {
    try {

      const res = await services.email.GET_SENT_MAIL(page, limit);
      setSentEmails(res?.data?.data);
      setTotalCount(res?.data?.pagination?.totalPages)
    } catch (err) {

    }
  }
  useEffect(() => {
    fetchAllData();
    //fetchSentEmails(mailPage, 10);
  }, [mailPage, labelID]);
  useEffect(() => {
    if (selectedLabelId || labelID) {
      setCurrentPage(1);
      fetchEmailsForLabel(selectedLabelId || labelID, 1);
    }
  }, [selectedLabelId, labelID]);

  const getAllProperty = async () => {
    try {
      const response = await services.customfield.GET_ALL_CUSTOM_FIELD();

      const data = response?.data?.data || [];
      setAllCustomFieldList(data);
    } catch (error) {
      console.error('Error fetching board list:', error);
    }
  };

  useEffect(() => {
    getAllProperty();
  }, [selectedBoardId]);

  useEffect(() => {
    const fetchAllSystemUsers = async () => {
      try {
        const query = new URLSearchParams();
        query.append("falsePagination", true);
        const response = await services.user?.GET_ALL_USER(query);
        if (response?.users) {
          setAllUsers(response.users);
        }
      } catch (error) {
        console.error("Error fetching full user list in AppViewer:", error);
      }
    };
    fetchAllSystemUsers();
  }, []);

  useEffect(() => {
    const fetchBoardUsers = async () => {
      try {
        if (selectedBoardId) {
          const page = 1;
          const falsePagination = true;
          const response = await services.userassignboard.GET_ASSIGN_USER_BY_BOARD_ID(
            selectedBoardId,
            "",
            falsePagination,
            page
          );
          const allData = response?.data?.data || [];
          const uniqueUsers = Array.from(
            new Map(allData.map((item) => [item.userId, item.User])).values()
          ).filter(Boolean);
          setUserList(uniqueUsers);
        } else if (allUsers.length > 0) {
          setUserList(allUsers);
        }
      } catch (error) {
        console.error("Error fetching board user list in AppViewer:", error);
      }
    };
    fetchBoardUsers();
  }, [selectedBoardId, allUsers]);
  useEffect(() => {
    if (selectedLabelId) {
      fetchEmailsForLabel(selectedLabelId, currentPage);
    }
  }, [currentPage]);

  async function fetchEmailsForLabel(labelId, page = 1) {
    try {
      const res = await labelService.GET_Label_By_Id(labelId, page, limit);

      const emailsData = res.data?.data?.emails || [];
      const data = res.data?.data || {};

      setPagination(data.pagination);

      setEmails(emailsData);
    } catch (error) {
      console.error("Error fetching emails for label:", error);
      setEmails([]);
    }
  }


  function transformBoardsToTree(boards) {

    return boards.map((board) => ({

      id: board.id,
      label: board.boardName,
      type: "board",
      expanded: false,
      selected: false,
      children: board.BoardLists
        ? board.BoardLists
          .slice()
          .sort((a, b) => Number(a.sequence) - Number(b.sequence))
          .map((col) => {

            return {
              id: col.id,
              label: col.coloum,
              type: "column",
              boardId: board.id,
              expanded: false,
              selected: false,
              children: [],
            };
          })
        : [],
    }));
  }

  function transformLabelsToTree(labels) {
    return labels.map((label) => ({
      id: label.id,
      label: label.name || "Unnamed",
      type: "label",
      expanded: false,
      selected: false,
      children:
        label.children && label.children.length > 0
          ? transformLabelsToTree(label.children)
          : [],
    }));
  }

  useEffect(() => {
    const handleClickOutside = () => setMenuOpenId(null);
    window.addEventListener("click", handleClickOutside);
    return () => window.removeEventListener("click", handleClickOutside);
  }, []);

  async function fetchTasksForBoard(boardId, columnId = null, page = 1, append = false) {
    try {
      const res = await task.GET_TASK({ boardId, limit, page });


      const tasksData = res.data?.data || {};
      const filteredTasks = columnId
        ? tasksData[columnId] || []
        : Object.values(tasksData).flat();

      setEmails(filteredTasks)

      setTasks((prev) => (append ? [...prev, ...filteredTasks] : filteredTasks));

      const paginationInfo = res.data?.pagination || {};
      setTaskPagination({
        currentPage: paginationInfo.currentPage || page,
        totalPages: paginationInfo.totalPages || 1,
      });

      setSelectedBoardId(boardId);
    } catch (error) {
      console.error("Error fetching tasks for board:", error);
      setTasks([]);
    }
  }

  useEffect(() => {
    if (selectedTab !== "WHATSAPP") {
      const handleScroll = () => {
        if (!listRef.current || !selectedBoardId) return;

        const { scrollTop, scrollHeight, clientHeight } = listRef.current;
        if (scrollHeight - scrollTop <= clientHeight + 50) {
          setTaskPagination((prev) => {
            if (prev.currentPage < prev.totalPages) {
              const nextPage = prev.currentPage + 1;
              fetchTasksForBoard(selectedBoardId, null, nextPage, true);
              return { ...prev, currentPage: nextPage };
            }
            return prev;
          });
        }
      };

      const listElement = listRef.current;
      if (listElement) listElement.addEventListener("scroll", handleScroll);
      return () => listElement && listElement.removeEventListener("scroll", handleScroll);
    }
  }, [selectedBoardId]);


  const depth = 0;
  function toggleExpand(id) {
    function toggle(node) {
      if (node.id === id) {
        const newExpanded = !node.expanded;
        if (newExpanded) {
          setLastExpandedId(id);
          sessionStorage.setItem('lastExpandedLabelId', id);
        } else {

        }
        return { ...node, expanded: newExpanded };
      }
      if (node.children) {
        return { ...node, children: node.children.map(toggle) };
      }
      return node;
    }
    setNode((prev) => toggle(prev));
  }

  function selectNode(id) {
    function select(node) {
      if (node.id === id) {
        if (node.type === "kanban-root") {
          setSelecteType(node.id)

        } else if (node.type === "label-root") {
          setSelecteType(node.id)


        } else if (node.type === "board") {
          setSelecteType("kanban-root")

          fetchTasksForBoard(node.id);
        } else if (node.type === "label") {
          setSelecteType("label-root")
          setSelectedLabelId(node.id);
          fetchEmailsForLabel(node.id);
        } else if (node.type === "column") {
          setSelecteType("kanban-root")
          fetchTasksForBoard(node.boardId, node.id);
        }
      }

      return {
        ...node,
        selected: node.id === id,
        children: node.children ? node.children.map(select) : undefined,
      };
    }

    setNode((prev) => select(prev));
  }








  function renderNode(node, depth) {
    const hasChildren = node.children && node.children.length > 0;

    return (

      <li
        key={node.id}
        role="treeitem"
        aria-expanded={hasChildren ? node.expanded : undefined}
        className="list-none"
      >
        <div
          className={`flex items-center p-2 cursor-pointer ${node.selected ? "bg-[#f2f6fc]" : ""
            }`}
          style={{ paddingLeft: (depth * 20) + 8 }}
          onClick={() => {
            selectNode(node.id);
            if (hasChildren && !node.expanded) {
              toggleExpand(node.id);
            }
          }}
        >
          {hasChildren ? (
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                toggleExpand(node.id);
              }}
            >
              {node.expanded ? <ExpandMore /> : <ChevronRight />}
            </IconButton>
          ) : (
            <div style={{ width: 40 }} />
          )}
          <LabelIcon className="mr-2" />
          <span className="flex-1 flex items-center justify-between min-w-0">
            <span className="truncate pr-2">{node.label}</span>

            {node.type === "label" && (
              <div className="relative ml-auto flex-shrink-0">
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    setMenuOpenId(menuOpenId === node.id ? null : node.id);
                  }}
                >
                  <MoreVert fontSize="small" />
                </IconButton>

                {menuOpenId === node.id && (
                  <div
                    className="absolute right-0 mt-1 w-24 bg-white border border-gray-200 rounded-md shadow-lg z-10"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <button
                      className="flex items-center gap-2 w-full px-2 py-1 text-sm hover:bg-gray-100"
                      onClick={() => {
                        setMenuOpenId(null);
                        handleEditLabel(node.id);
                      }}
                    >
                      <Edit fontSize="small" /> Edit
                    </button>
                    <button
                      className="flex items-center gap-2 w-full px-2 py-1 text-sm hover:bg-gray-100 text-red-600"
                      onClick={() => {
                        setMenuOpenId(null);
                        handleDeleteLabel(node.id);
                      }}
                    >
                      <Delete fontSize="small" /> Delete
                    </button>
                  </div>
                )}
              </div>
            )}
          </span>

        </div>

        {hasChildren && node.expanded && (
          <ul role="group" className="pl-1">
            {node.children.map((child) => renderNode(child, depth + 1))}
          </ul>
        )}
      </li>


    );
  }
  // const [selectedEmailsIds, setSelectedEmailsIds] = useState([]);
  const [selectedEmailsIds, setSelectedEmailsIds] = useState(() => {
    const saved = getLocalStorageItem("selectedEmailsIds");
    if (saved) {
      try {
        const parsed = saved;
        if (Array.isArray(parsed)) {
          return parsed;
        }
      } catch (e) {
        console.error("Failed to parse selectedEmailsIds from localStorage", e);
      }
    }

    return [];
  });
  const [selectedMailId, setSelectedMailId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [taskLoading, setTaskLoading] = useState(false);
  const [emailLimit, setEmailLimit] = useState(10);
  const [emailName, setEmailName] = useState([]);
  const [selected, setSelected] = useState("");
  const [selectedWhatspp, setSelectedWhatspp] = useState("");
  const [allWhatsappData, setAllWhatsappData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const moduleName = "board";
  const [columns, setColumns] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedBoard, setSelectedBoard] = useState([]);
  const [localSt, setLocalSt] = useState(
    () => getLocalStorageItem("board") ?? ""
  );
  const [isShiftPressedMail, setIsShiftPressedMail] = useState(false);
  const [valueTab, setValueTab] = useState(0);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [pageWhatsapp, setPageWhatsapp] = useState(1);
  const [searched, setSearched] = useState("");
  const [labelEmail, setLabelEmail] = useState("CATEGORY_PERSONAL");
  const [columnAddStatus, setColumnAddStatus] = useState(false);
  const [pendingRemoval, setPendingRemoval] = useState(new Set());
  const dispatch = useDispatch();
  const userDataRaw = getLocalStorageItem("userData");
  let userData;
  if (typeof userDataRaw === "string") {
    try {
      userData = JSON.parse(userDataRaw);
    } catch {
      userData = null;
    }
  } else {
    userData = userDataRaw;
  }

  const userDataRef = useRef(userData);
  const selectedBoardIdRef = useRef(selectedBoardId);
  const selectedEmailsIdsRef = useRef(selectedEmailsIds);

  useEffect(() => {
    userDataRef.current = userData;
  }, [userData]);

  useEffect(() => {
    selectedBoardIdRef.current = selectedBoardId;
  }, [selectedBoardId]);

  useEffect(() => {
    selectedEmailsIdsRef.current = selectedEmailsIds;
  }, [selectedEmailsIds]);

  const role = userData?.role;
  const userId = userData?.id;

  const sidebarRef = useRef(null);
  const [allWhatsaapUserProfile, setAllWhatsaapUserProfile] = useState([]);
  const [selectedProfileId, setSelectedProfileId] = useState("");
  const [boardName, setBoardName] = useState([]);
  const [isBoardFetched, setIsBoardFetched] = useState(false);
  const [sortby, setSortBy] = useState("title");
  const [sortOrder, setSortOrder] = useState("ASC");
  const Action = location?.state?.activeButton;
  const ActionPage = location?.state?.AllMailPage;
  const [activeButton, setActiveButton] = useState(Action || "board");
  const { columnIndex, selectedTab, whatsAppStatus, emailStatus } = useSelector(
    (state) => ({
      columnIndex: state.redux.columnIndex,
      selectedTab: state.redux.selectedTab,
      whatsAppStatus: state.redux.whatsAppStatus,
      emailStatus: state.redux.emailStatus,
    }),
    (prev, next) =>
      prev.columnIndex === next.columnIndex &&
      prev.selectedTab === next.selectedTab &&
      prev.whatsAppStatus === next.whatsAppStatus &&
      prev.emailStatus === next.emailStatus
  );

  const { isTableVisible } = useSelector((state) => state?.redux);
  const [noMailFound, setNoMailFound] = useState(false);
  const [inboxFilterMailData, setInboxFilterMailData] = useState([]);
  const [taskMail, setTaskMail] = useState([]);
  const navigate = useNavigate();
  const [debouncedSearch, setDebouncedSearch] = useState(searched);
  const combinedArray = Object.values(taskMail).flat();
  const [totalPages, setTotalPages] = useState(1);
  const [boardLoading, setBoardLoading] = useState(false);
  const [isMember, setIsMember] = useState(false);
  const [permissions, setPermissions] = useState({
    addTask: false,
    addList: false,
    renameList: false,
    deleteList: false,
  });

  useEffect(() => {
    const checkPermissions = () => {
      if (isMember) {
        setPermissions({
          addTask: true,
          addList: true,
          renameList: true,
          deleteList: true,
          addAutomations: true,
          allMail: true,
          addIncomingMail: true,
          addGmail: true,
          addWhatsapp: true,
          boardManagement: true,
        });
        return;
      }
      setPermissions({
        addTask: PrivilegesChecker("Add a Task"),
        addList: PrivilegesChecker("Add a List"),
        renameList: PrivilegesChecker("Rename this List"),
        deleteList: PrivilegesChecker("Delete this List"),
        addAutomations: PrivilegesChecker("Create automation"),
        allMail: PrivilegesChecker("All email"),
        addIncomingMail: PrivilegesChecker("Add incomings emails to this list"),
        addGmail: PrivilegesChecker("Add Gmail Account"),
        addWhatsapp: PrivilegesChecker("Add whatsapp Account"),
        boardManagement: PrivilegesChecker("Board Management"),
      });
    };
    checkPermissions();
  }, [isMember]);




  const handleScrollWhatsapp = () => {
    const sidebar = sidebarRef.current;
    if (!sidebar) return;

    if (sidebar.scrollTop + sidebar.clientHeight >= sidebar.scrollHeight) {
      GET_CONTACT_WHATSAPP(page + 1, selectedProfileId);
      setPage(page + 1);
    }
  };
  const UserId = userData?.id;
  useEffect(() => {
    if (selectedTab == "WHATSAPP") {
      const sidebar = sidebarRef.current;
      if (!sidebar) return;

      sidebar.addEventListener("scroll", handleScrollWhatsapp);
      return () => sidebar.removeEventListener("scroll", handleScrollWhatsapp);
    }
  }, [page, selectedProfileId]);

  useEffect(() => {
    setLocalStorageItem("tasks", tasks);
  }, [tasks, columns]);

  const handleClick = (category) => {
    setSelected(category);
    if (category === "primary") {
      setOpen();
    }
  };

  useEffect(() => {
    try {
      handleSelectedBoard(selectedBoard)
    } catch (error) {
      console.error("Error:", error)
    }
  }, [selectedBoard])

  useEffect(() => {
    const savedBoard = getLocalStorageItem("board");
    if (savedBoard) {
      try {
        const parsedBoard = savedBoard;
        if (!selectedBoardId || selectedBoardId !== parsedBoard.value) {
          setSelectedBoard(parsedBoard);
          setSelectedBoardId(parsedBoard.value);
          // Redundant handleSelectedBoard(parsedBoard) removed because separate useEffect handles selectedBoard change
        }
      } catch (error) {
        console.error("Error parsing saved board:", error);
        removeLocalStorageItem("board");
      }
    }
  }, []);

  useEffect(() => {
    setLocalStorageItem("board", localSt);
  }, [localSt]);

  useEffect(() => {
    if (boardName && boardName.length > 0 && !selectedBoardId) {
      const savedBoard = getLocalStorageItem("board");
      if (savedBoard) {
        try {
          const parsedBoard = savedBoard;
          const boardExists = boardName.some(
            (b) => b.value === parsedBoard.value
          );
          if (boardExists) {
            setSelectedBoard(parsedBoard);
            setSelectedBoardId(parsedBoard.value);
            handleSelectedBoard(parsedBoard);
          } else {
            setSelectedBoard(boardName[0]);
            setSelectedBoardId(boardName[0].value);
            handleSelectedBoard(boardName[0]);
          }
        } catch (error) {
          console.error("Error parsing saved board:", error);
          setSelectedBoard(boardName[0]);
          setSelectedBoardId(boardName[0].value);
          handleSelectedBoard(boardName[0]);
        }
      } else {
        setSelectedBoard(boardName[0]);
        setSelectedBoardId(boardName[0].value);
        handleSelectedBoard(boardName[0]);
      }
    }
  }, [boardName, selectedBoardId]);

  const getColor = (category) => {
    return selected === category
      ? "text-blue-500 border-b-4 border-blue-500"
      : "text-current";
  };

  const getColorWhatsapp = (category) => {
    return selectedWhatspp === category
      ? "text-blue-500 border-b-4 border-blue-500"
      : "text-current";
  };
  const getAllAutomation = async () => {

    try {
      const response = await services.automations.GET_ALL_AUTOMATIONS(`isColumnAutomation=true`);

      if (response) {
        setColumnAutomation(response)
      }
    } catch (e) {
      toast.error('Failed to fetch automations');
    }
  };

  const moveTaskUp = (taskId) => {
    setTasks((prevTasks) => {
      const taskIndex = prevTasks.findIndex((task) => task.id === taskId);
      if (
        taskIndex > 0 &&
        prevTasks[taskIndex].columnId === prevTasks[taskIndex - 1].columnId
      ) {
        const updatedTasks = [...prevTasks];
        [updatedTasks[taskIndex - 1], updatedTasks[taskIndex]] = [
          updatedTasks[taskIndex],
          updatedTasks[taskIndex - 1],
        ];
        return updatedTasks;
      }
      return prevTasks;
    });
  };

  const moveTaskDown = (taskId) => {
    setTasks((prevTasks) => {
      const taskIndex = prevTasks.findIndex((task) => task.id === taskId);
      if (
        taskIndex < prevTasks.length - 1 &&
        prevTasks[taskIndex].columnId === prevTasks[taskIndex + 1].columnId
      ) {
        const updatedTasks = [...prevTasks];
        [updatedTasks[taskIndex + 1], updatedTasks[taskIndex]] = [
          updatedTasks[taskIndex],
          updatedTasks[taskIndex + 1],
        ];
        return updatedTasks;
      }
      return prevTasks;
    });
  };

  const addTaskToColumn = ({ title, user, columnId, date, deadlineDate }) => {
    const newTask = {
      id: uuid(),
      title,
      user,
      columnId,
      date,
      deadlineDate,
    };
    const updatedTasks = [...tasks, newTask];
    setTasks(updatedTasks);
    setLocalStorageItem("tasks", updatedTasks);
  };

  const updateTitleInLocalStorage = (itemId, editTaskTitle) => {
    const existingData = tasksLocal() || [];
    const updatedData =
      existingData?.length > 0 &&
      existingData?.map((item) => {
        if (item.id === itemId) {
          return { ...item, title: editTaskTitle };
        }
        return item;
      });
    setTasks(updatedData);
    setLocalStorageItem("tasks", updatedData);
  };

  const updateColunTitleInLocalStorage = (columnID, editColumnTitle) => {
    const existingData = columnsLocal() || [];
    const updatedData =
      existingData?.length > 0 &&
      existingData?.map((item) => {
        if (item.id === columnID) {
          return { ...item, title: editColumnTitle };
        }
        return item;
      });
    setColumns(updatedData);
  };

  const getAllInboxMailFilter = async (currentPage) => {
    setLoading(true);
    const data = {
      page: currentPage,
      limit: 10,
    };
    const currentSelected = selectedEmailsIdsRef.current;
    console.log(currentSelected,"currentSelected")
    if (currentSelected && currentSelected.length > 0) {
      data.gmailUserId = currentSelected.map((element) => element.value);
    }
    const query = new URLSearchParams(data).toString();
    const response = await services.email.GET_EMAIL_BY_SELECTED_USER(query);
    const emails = response?.data?.data?.emails || [];

    const filteredEmails = emails.filter(
      (item) => !pendingRemoval.has(item.gmailMessageId)
    );

    setInboxFilterMailData((prev) =>
      currentPage === 1 ? filteredEmails : [...prev, ...filteredEmails]
    );
    setTotalPages(Math.ceil(response?.data?.data?.total / 10));
    setLoading(false);

    if (filteredEmails.length > 0) {
      const currentSelectedIdExists = filteredEmails.some(
        (email) => email.gmailMessageId === selectedMailId
      );
      if (!currentSelectedIdExists) {
        setSelectedMailId(filteredEmails[0].gmailMessageId);
      }
    } else {
      setSelectedMailId(null);
    }
  };

  const updateDeadlineDateInLocalStorage = (itemId, date) => {
    const updatedTasks =
      tasks?.length > 0 &&
      tasks.map((task) => {
        if (task.id === itemId) {
          return { ...task, deadline: date };
        }
        return task;
      });
    setTasks(updatedTasks);
    setLocalStorageItem("tasks", updatedTasks);
  };

  const handleUpdateTask = async (newDate, type = "reminder", taskItem) => {
    try {
      const data = {
        [type]: newDate,
      };
      const response = await services.task.UPDATE_TASK(taskItem?.id, data);
      if (response) {
        getTaskMailIndbox();
      }
    } catch (error) {
      console.error("Error updating task:", error);
    }
  };

  const handleCheckboxClick = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleViewDetails = (item) => {
    navigate("/mailinbox", { state: { selectedMail: item } });
  };

  const handleAddColumn = async (columnInputAdd) => {
    const currentBoardId = getCurrentBoardId();
    if (!currentBoardId) {
      toast.error("Please select a board before adding a list.");
      return;
    }
    if (
      !columnInputAdd ||
      typeof columnInputAdd !== "string" ||
      columnInputAdd.trim() === ""
    ) {
      toast.error("Please enter a valid list name.");
      return;
    }

    const trimmedInput = columnInputAdd.trim().toLowerCase();
    const isDuplicate = columns.some(
      (col) =>
        typeof col?.title === "string" &&
        col?.title?.trim().toLowerCase() === trimmedInput
    );

    if (isDuplicate) {
      toast.error("List name already exists, please choose another name.");
      return;
    }

    const obj = {
      coloum: columnInputAdd.trim(),
      boardId: currentBoardId,
      sequence: columns?.length + 1,
      className: "#00f767",
      borderColor: "#00f767",
    };

    try {
      await services.column.CREATE_COLUMN(obj);
      handleSelectedBoard(selectedBoard);
      toast.success("Column created successfully.");
    } catch (e) {
      console.error("Error adding column:", e);
      toast.error("Failed to add column.");
    }
  };

  const moveColumn = (fromIndex, toIndex) => {
    setColumns((prevColumns) => {
      const newColumns = [...prevColumns];
      const [movedColumn] = newColumns.splice(fromIndex, 1);
      newColumns.splice(toIndex, 0, movedColumn);

      updateColumnSequence(newColumns);

      return newColumns;
    });
  };

  const updateColumnSequence = async (columns) => {
    const sequenceData =
      columns?.length > 0 &&
      columns.map((col, index) => ({
        id: col.id,
        sequence: index + 1,
      }));

    try {
      await services.board.SEQUENCE(sequenceData, selectedBoardId);
    } catch (e) {
      console.error("Error updating sequence:", e);
    }
  };

  const handleSelectedBoard = async (id) => {
    if (!id?.value) {
      return;
    }

    try {
      if (role === "User") {
        const response = await services.userassignboard.GET_UserAssignBoard_ID(
          UserId
        );
        const assignedBoards = response?.data?.data || [];
        const assignedBoard = assignedBoards.find(
          (board) => board.boardId === id.value
        );
        if (!assignedBoard) return;

        if (assignedBoard.isManager === true) {
          // Manager: call SELECTED_BOARD for correct sequence, filter to assigned cols
          const boardResp = await services.board.SELECTED_BOARD(id?.value);
          const allCols = boardResp?.data || [];
          const assignedIds = new Set(
            assignedBoard?.boardListId?.map((item) => item.value || item.id) || []
          );
          const assignedColumns = allCols
            .slice()
            .sort((a, b) => Number(a.sequence) - Number(b.sequence))
            .filter((col) => assignedIds.size === 0 || assignedIds.has(col.id))
            .map((col, index) => ({
              id: col.id,
              title: col.label || col.coloum,
              className: col.colour || "#00f767",
              borderColor: col.colour || "#00f767",
              sequence: col.sequence,
              index,
            }));

          dispatch(addColumnsDetails(assignedColumns));
          setLocalStorageItem("board", { value: assignedBoard.boardId });
          setColumns(assignedColumns);
          setIsMember(true);

          return;
        }
        setIsMember(false);

        // Always call SELECTED_BOARD to get columns in admin-defined sequence order
        const boardResponse = await services.board.SELECTED_BOARD(id?.value);
        const allBoardColumns = boardResponse?.data || [];

        // Determine which column IDs this user is allowed to see
        const hasAddList = PrivilegesChecker("Add a List");
        let assignedColumns;

        if (hasAddList) {
          // User can see all columns — use SELECTED_BOARD order directly
          assignedColumns = allBoardColumns
            .slice()
            .sort((a, b) => Number(a.sequence) - Number(b.sequence))
            .map((item) => ({
              id: item?.id,
              title: item?.coloum,
              className: item?.colour || "#00f767",
              borderColor: item?.colour || "#00f767",
              sequence: item?.sequence,
            }));
        } else {
          // Filter to only the assigned columns, preserving SELECTED_BOARD order
          const assignedIds = new Set(
            (assignedBoard?.boardListId || []).map((col) => col.value || col.id)
          );
          const isAllColumns =
            assignedBoard?.boardListId?.some((col) => col.id === "*") ||
            assignedIds.size === 0;

          assignedColumns = allBoardColumns
            .slice()
            .sort((a, b) => Number(a.sequence) - Number(b.sequence))
            .filter((item) => isAllColumns || assignedIds.has(item.id))
            .map((item) => ({
              id: item?.id,
              title: item?.coloum,
              className: item?.colour || "#00f767",
              borderColor: item?.colour || "#00f767",
              sequence: item?.sequence,
            }));
        }

        if (PrivilegesChecker("Add a Task")) {
          const data = {
            boardId: assignedBoard?.boardId,
            userId: UserId,
            boardListId: assignedBoard?.Board?.BoardLists?.map((col) => ({
              value: col.id,
              label: col.coloum
            })),
          };
          try {
            const response =
              await services.userassignboard.UPDATE_UserAssignBoard(
                assignedBoard?.id,
                data
              );
            if (response.status === 200) {
            }
          } catch (e) {
            console.error(e);
            toast.error("Failed to update assignment");
          }
        }

        dispatch(addColumnsDetails(assignedColumns));
        setLocalStorageItem("board", id);
        setColumns(assignedColumns);

      } else {
        const response = await services.board.SELECTED_BOARD(id?.value);

        const data =
          response?.data && response.data.length > 0
            ? response.data
              .slice()
              .sort((a, b) => Number(a.sequence) - Number(b.sequence))
              .map((item) => ({
                id: item?.id,
                title: item?.coloum,
                className: item?.colour,
                borderColor: item?.colour,
              }))
            : [];

        dispatch(addColumnsDetails(data));
        setLocalStorageItem("board", id);
        setColumns(data);
      }
    } catch (e) {
      console.error("Error fetching board:", e);
    }
  };
  const stableSelectedEmailIds = useMemo(
    () => selectedEmailsIds?.map(e => e.value) || [],
    [selectedEmailsIds]
  );

  const stablePendingRemoval = useMemo(
    () => new Set(Array.from(pendingRemoval)),
    [pendingRemoval]
  );


  const getTaskMailIndbox = useCallback(async () => {
    setLoading(true);

    const currentBoardId = getCurrentBoardId();
    if (!currentBoardId) {
      setLoading(false);
      return;
    }

    if (stableSelectedEmailIds.length === 0) {
      setLoading(false);
      return;
    }
    try {
      const data = {
        limit: emailLimit,
        page: 1,
        boardId: currentBoardId,
        search: searched || "",
      };

      const query = new URLSearchParams(data).toString();
      const response = await services.email.GET_EMAIL_BY_DATE(query, currentBoardId);

      if (Array.isArray(response?.data?.emails)) {
        const filteredList = response.data.emails.filter(
          (item) => !stablePendingRemoval.has(item.gmailMessageId)
        );

        setOriginalTaskList(response.data.emails);

        if (filteredList.length === 0) setNoMailFound(true);
      } else {
        setOriginalTaskList([]);
        setTaskList([]);
        setNoMailFound(true);
      }
    } catch (error) {
      console.error(error);
      setNoMailFound(true);
    } finally {
      setLoading(false);
    }
  }, [
    emailLimit,
    searched,
    stableSelectedEmailIds,
    stablePendingRemoval
  ]);
  const processedMessages = useRef(new Set());

  const handleChange = async (selectedOptions) => {
    setSelectedEmailsIds(selectedOptions);
    setLocalStorageItem("selectedEmailsIds", selectedOptions);
  };
  const handleEmailSync = async (newEmails) => {

    const currentSelected = selectedEmailsIdsRef.current || [];
    const currentSelectedIds = currentSelected.map(item => item.value);

    const uniqueEmails = newEmails.filter(
      (email) => !processedMessages.current.has(email.id)
    );

    if (uniqueEmails.length === 0) {
      return;
    }

    // Only process and refresh if emails belong to currently selected accounts
    const hasRelevantEmails = uniqueEmails.some(email =>
      currentSelectedIds.includes(email.gmailUserId)
    );

    if (!hasRelevantEmails && currentSelectedIds.length > 0) {
      console.log("Ignoring sync event for unselected accounts");
      return;
    }

    uniqueEmails.forEach((email) => {
      processedMessages.current.add(email.id);
    });
    const getHeaderValue = (headers, name) => {
      if (!headers || !Array.isArray(headers)) return "";
      const header = headers.find(
        (h) => h.name?.toLowerCase() === name.toLowerCase()
      );
      return header?.value || "";
    };

    const decodeBase64 = (str) => {
      try {
        return atob(str.replace(/-/g, "+").replace(/_/g, "/"));
      } catch (err) {
        console.warn("Base64 decode failed:", err);
        return "";
      }
    };

    const extractBody = (parts) => {
      if (!Array.isArray(parts)) return "";
      for (const part of parts) {
        if (["text/plain", "text/html"].includes(part.mimeType)) {
          if (part.body?.data) {
            return decodeBase64(part.body.data);
          }
        }
        if (Array.isArray(part.parts)) {
          const nested = extractBody(part.parts);
          if (nested) return nested;
        }
      }
      return "";
    };

    const parsedEmails = newEmails.map((newEmail) => {
      const payload = newEmail.payload;

      return {
        id: Date.now() + Math.random(),
        gmailMessageId: newEmail?.id || "",
        attachmentPaths: null,
        boardId: null,
        body: (() => {
          if (payload?.body?.data) {
            return decodeBase64(payload.body.data);
          } else if (payload?.parts) {
            return extractBody(payload.parts);
          }
          return newEmail?.snippet || "";
        })(),
        contactId: null,
        createdAt: new Date().toISOString(),
        createdAtEmail: (() => {
          const timestamp = parseInt(newEmail?.internalDate);
          return isNaN(timestamp)
            ? new Date().toISOString()
            : new Date(timestamp).toISOString();
        })(),
        fetchedAt: new Date().toISOString(),
        gmailUserId: newEmail.gmailUserId || (selectedEmailsIdsRef.current && selectedEmailsIdsRef.current[0] ? selectedEmailsIdsRef.current[0].value : ""),
        isTaskCreated: false,
        labels: Array.isArray(newEmail?.labelIds)
          ? newEmail.labelIds.join(",")
          : "",
        messageRead: newEmail?.labelIds?.includes("UNREAD") ? "unread" : "read",
        name: (() => {
          const from = getHeaderValue(payload?.headers, "From");
          return from ? from.split("<")[0].trim().replace(/"/g, "") : "";
        })(),
        sentBy: getHeaderValue(payload?.headers, "From"),
        sentTo: getHeaderValue(payload?.headers, "To"),
        subject: getHeaderValue(payload?.headers, "Subject"),
        status: true,
        updatedAt: new Date().toISOString(),
        updatedAtEmail: null,
        isNew: true,
      };
    });
    getAllInboxMailFilter(1);
    getTaskMail(1, {}, selectedBoardIdRef.current);
  };

  useEffect(() => {
    gmailSocket.on("email-sync", handleEmailSync);
    return () => gmailSocket.off("email-sync", handleEmailSync);
  }, []);


  useEffect(() => {
    setInboxFilterMailData([]);
    setPage(1);
    if (selectedEmailsIds?.length > 0) {
      getAllInboxMailFilter(1);
    }
  }, [stableSelectedEmailIds]);


  const checkAndCreateAutomationTask = async (emailData) => {
    try {
      const allAutomations = await services.automations.GET_ALL_AUTOMATIONS();

      const matchingAutomation = allAutomations.find(
        (automation) =>
          automation.when?.gmailUserId === emailData.gmailUserId &&
          automation.status !== false
      );

      if (matchingAutomation) {
        getTaskMail();

        return true;
      }

      return false;
    } catch (error) {
      console.error("Error in automation check:", error);
      return false;
    }
  };

  const getAllLinkedEmail = async () => {
    try {
      const response = await services.email.Get_The_Linked_Email();
      if (!response) return;

      const options = Array.isArray(response?.data) && response.data.length > 0
        ? response.data.map((email) => ({
          label: email.email,
          value: email.id,
          color: email.colour,
        }))
        : [];

      const userData = userDataRef.current;
      const availableOptions = userData?.role === "User" ? (userData?.usersEmailMapped || []) : options;
      setFilterList(availableOptions);

      const savedSelection = getLocalStorageItem("selectedEmailsIds");
      if (savedSelection && Array.isArray(savedSelection) && savedSelection.length > 0) {
        setSelectedEmailsIds(savedSelection);
        return;
      }

      if (availableOptions.length > 0) {
        const defaultSelection = [availableOptions[0]];
        setSelectedEmailsIds(defaultSelection);
        setLocalStorageItem("selectedEmailsIds", defaultSelection);
      } else {
        setSelectedEmailsIds([]);
        setLocalStorageItem("selectedEmailsIds", []);
      }
    } catch (error) {
      console.error("Error getting linked emails:", error);
    }
  };



  const [allData, setAllData] = useState()
  const GET_CONTACT_WHATSAPP = async (page, id) => {
    if (!id) return;

    setLoading(true);
    try {
      let data;

      const response = await services.Whatsapp.GET_BYID_WHATSAPP_PROFILE(id);
      data = response?.data;

      const totalData = Math.ceil(data.totalCount / 10 || 0);
      if (page >= totalData) {
        setHasMore(false);
      }
      setAllWhatsappData(data?.data?.Contacts);
      setAllData(data?.data)
    } catch (e) {
      console.error("Error fetching contacts:", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedTab == "GMAIL") { getAllLinkedEmail(); }
    if (selectedTab === "WHATSAPP") {
      getClientWhatsapp();
    }
  }, [selectedTab]);

  useEffect(() => {
    if (selectedTab === "WHATSAPP") {
      if (selectedProfileId || selectedWhatspp) {
        GET_CONTACT_WHATSAPP(page, selectedProfileId);
      }
    }
  }, [selectedProfileId, selectedWhatspp, page]);

  const getClientWhatsapp = async () => {
    try {
      const { data } = await services.Whatsapp.GET_ALL_CLIENT();
      const filterProfileData = data?.filter(
        (item) => item?.name !== null && item?.name !== ""
      );
      if (filterProfileData?.length > 0) {
        const firstId = filterProfileData[0]?.id;
        setSelectedProfileId(firstId);
        setSessionId(filterProfileData?.clientId)
        GET_CONTACT_WHATSAPP(page, firstId);
      }
      setAllWhatsaapUserProfile(filterProfileData || []);
    } catch (e) {
      console.error(e);
    }
  };

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (
      scrollTop + clientHeight >= scrollHeight - 50 &&
      !loading &&
      page < totalPages
    ) {
      setPage((prev) => {
        const nextPage = prev + 1;
        getAllInboxMailFilter(nextPage);
        return nextPage;
      });
    }
  };

  const handleDragEnd = (gmailMessageId) => {
    setPendingRemoval((prev) => {
      const newPending = new Set(prev);
      if (newPending.has(gmailMessageId)) {
        newPending.delete(gmailMessageId);
        getAllInboxMailFilter(page);
      } else {
        newPending.add(gmailMessageId);

        setInboxFilterMailData(
          inboxFilterMailData.filter(
            (item) => !newPending.has(item.gmailMessageId)
          )
        );
      }
      return newPending;
    });
  };

  const generateMailInbox = () => {
    return (
      <Droppable droppableId="inbox">
        {(provided) => (
          <div {...provided.droppableProps} ref={provided.innerRef}>
            {selectedEmailsIds?.length > 0 && inboxFilterMailData?.length > 0 &&
              inboxFilterMailData?.map((item, index) => (
                <InboxData
                  key={item?.id}
                  item={item}
                  open={open}
                  setOpen={setOpen}
                  getTaskMailIndbox={getAllInboxMailFilter}
                  onCheckboxClick={handleCheckboxClick}
                  onViewDetails={() => handleViewDetails(item)}
                  setIsShiftPressedMail={setIsShiftPressedMail}
                  isShiftPressedMail={isShiftPressedMail}
                  taskList={taskList}
                  onDragEnd={handleDragEnd}
                  filterList={filterList}
                  role={role}
                  selectedEmailsIds={selectedEmailsIds}
                  handleChange={handleChange}
                  selectedMailId={selectedMailId}
                  setSelectedMailId={setSelectedMailId}
                  selectedBoardId={selectedBoardId}
                  setInboxFilterMailData={setInboxFilterMailData}
                  index={index}
                />
              ))}
            {provided.placeholder}
            {loading && (
              <div style={{ textAlign: "center", padding: "10px" }}>
                <Loading />
              </div>
            )}
          </div>
        )}
      </Droppable>
    );
  };
  const generateMailBoard = () => {
    return (
      <Droppable droppableId="board-inbox">
        {(provided) => (
          <div {...provided.droppableProps} ref={provided.innerRef}>
            {combinedArray?.length > 0 &&
              combinedArray?.map((item, index) => (
                <InboxData
                  key={item?.id}
                  item={item}
                  open={open}
                  setOpen={setOpen}
                  getTaskMailIndbox={getAllInboxMailFilter}
                  onCheckboxClick={handleCheckboxClick}
                  onViewDetails={() => handleViewDetails(item)}
                  setIsShiftPressedMail={setIsShiftPressedMail}
                  isShiftPressedMail={isShiftPressedMail}
                  taskList={taskList}
                  onDragEnd={handleDragEnd}
                  filterList={filterList}
                  role={role}
                  selectedEmailsIds={selectedEmailsIds}
                  handleChange={handleChange}
                  selectedMailId={selectedMailId}
                  setSelectedMailId={setSelectedMailId}
                  selectedBoardId={selectedBoardId}
                  setInboxFilterMailData={setInboxFilterMailData}
                  columns={columns}
                  index={index}
                />
              ))}
            {provided.placeholder}
            {taskLoading && (
              <div style={{ textAlign: "center", padding: "10px" }}>
                <Loading />
              </div>
            )}
          </div>
        )}
      </Droppable>
    );
  };

  const isEmptyTaskData = (data = {}) => {
    if (!data || Object.keys(data).length === 0) return true;

    return Object.values(data).every(
      arr => !Array.isArray(arr) || arr.length === 0
    );
  };

  const getTaskMail = async (pageArg = 1, options = {}) => {
    const boardId = selectedBoardId;
    if (!boardId) return null;

    setTaskLoading(true);

    // Resolve filters — handle multi-select for assignee (user.name) and property (customProperty)
    let filterParams = {};
    filters.forEach(f => {
      if (f.field && f.value) {
        let resolvedValue = f.value;
        if (f.field === 'user.name' && Array.isArray(resolvedValue)) {
          const names = resolvedValue.map((u) => u.label).filter(Boolean);
          if (names.length > 0) {
            filterParams = { ...filterParams, field: f.field, value: names.join(',') };
          }
        } else if (f.field === 'customProperty' && Array.isArray(resolvedValue)) {
          const ids = resolvedValue.map((p) => p.value).filter(Boolean);
          if (ids.length > 0) {
            filterParams = { ...filterParams, field: f.field, value: ids.join(',') };
          }
        } else if (typeof resolvedValue === 'string' && resolvedValue.trim() !== '') {
          filterParams = { ...filterParams, field: f.field, value: resolvedValue };
        }
      }
    });

    try {
      const response = await services.task.GET_TASK({
        page: pageArg,
        limit: 10,
        boardId,
        ...filterParams,
        ...(activeButton === "table" && {
          sortBy: sortby,
          sortOrder,
          query: "table"
        })
      });

      const data = response?.data?.data || {};
      const totalPages = Number(response?.data?.totalPages) || 1;
      const currentPage = Number(response?.data?.currentPage) || pageArg;

      // 🔴 STOP condition: EMPTY DATA
      const noMoreData = isEmptyTaskData(data);

      setTaskMail(prev => {
        if (!options.append || currentPage === 1) return data;
        if (noMoreData) return prev; // do not merge empty data

        const merged = { ...prev };

        Object.keys(data).forEach(colId => {
          const prevArr = prev[colId] || [];
          const newArr = data[colId] || [];

          const existingIds = new Set(prevArr.map(t => t.id));
          merged[colId] = [
            ...prevArr,
            ...newArr.filter(t => !existingIds.has(t.id))
          ];
        });

        return merged;
      });

      return { currentPage, totalPages, noMoreData };
    } catch (error) {
      console.error("Error fetching task emails:", error);
      return null;
    } finally {
      setTaskLoading(false);
    }
  };





  const handleGetWhatsappTask = (id) => {
    const data = [...allWhatsappData];
    if (data && data?.length > 0) {
      const filterData = data.filter((idFil) => idFil?.id !== id);

      setAllWhatsappData(filterData);
    }

    if (boardOptions.length === 0) {
      setColumns([]);
      dispatch(addColumnsDetails([]));
      removeLocalStorageItem("columns");
      return;
    }
  };
  const [selectedWhatsappItem, setSelectedWhatsappItem] = useState()
  const generateWhatsAppInbox = () => {
    return (
      <Droppable droppableId="whatsapp-inbox">
        {(provided) => (
          <div {...provided.droppableProps} ref={provided.innerRef}>
            {allWhatsappData?.length > 0 &&
              allWhatsappData?.map((item, index) => {
                return (
                  <WhatsappData
                    key={item?.id}
                    item={item}
                    setIsShiftPressedMail={setIsShiftPressedMail}
                    isShiftPressedMail={isShiftPressedMail}
                    index={index}
                    onItemDrag={(onItemDrag) =>
                      handleGetWhatsappTask(onItemDrag?.item?.id)
                    }
                    onClick={() => { setSelectedWhatsappItem(item); setActiveButton("") }}
                    allData={allData}
                  />
                );
              })}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    );
  };
  useEffect(() => {
    if (columnIndex?.from >= 0 && columnIndex?.to >= 0) {
      const updatedColumns = [...columns];
      const [movedColumn] = updatedColumns.splice(columnIndex?.from, 1);
      updatedColumns.splice(columnIndex?.to, 0, movedColumn);

      setColumns(updatedColumns);
      const sequenceFun = async () => {
        const data =
          updatedColumns &&
          updatedColumns?.length > 0 &&
          updatedColumns?.map((item, index) => ({
            id: item?.id,
            sequence: index + 1,
          }));
        if (data) {
          try {
            await services.board.SEQUENCE(data, selectedBoardId);
          } catch (e) {
            console.error(e);
          }
        }
      };
      if (updatedColumns[0] != undefined) {
        sequenceFun();
      }
    }
  }, [columnIndex]);

  const handleChangeTab = (event, newValue) => {
    setValueTab(newValue);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searched);
    }, 500);
    return () => clearTimeout(timer);
  }, [searched]);

  useEffect(() => {
    if (debouncedSearch && debouncedSearch.length > 0) {
      if (selectedTab === "GMAIL" && selectedEmailsIds.length > 0) {
        setActiveButton("board")
      }
    }
    requestSearch(debouncedSearch);
  }, [debouncedSearch]);

  const clearSearch = () => {
    // cancel axios / fetch
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    requestIdRef.current += 1;

    setInboxFilterMailData([]);
    setAllWhatsappData([]);
    setNoMailFound(false);
    setLoading(false);
  };

  const requestSearch = async (searchedVal) => {
    setSearched(searchedVal);

    if (!searchedVal || searchedVal.length === 0) {
      if (selectedTab === "GMAIL" && selectedEmailsIds.length > 0) {
        getAllInboxMailFilter(1);
      } else if (selectedTab === "WHATSAPP") {
        if (selectedProfileId) {
          GET_CONTACT_WHATSAPP(page, selectedProfileId);
        } else {
          setAllWhatsappData([]);
        }
      } else {
        setInboxFilterMailData([]);
        setAllWhatsappData([]);
      }
      setNoMailFound(false);
      return;
    }

    if (selectedTab === "GMAIL" && selectedEmailsIds.length > 0) {
      const emails = selectedEmailsIds.map((item) => item.label);
      try {
        setLoading(true);
        const response = await services.email.EMAIL_SEARCH_BY_QUERY(emails, searchedVal);

        const data = Array.isArray(response?.data?.data) ? response.data.data : [];
        setInboxFilterMailData(data);
        setNoMailFound(data.length === 0);
      } catch (err) {
        setInboxFilterMailData([]);
        setNoMailFound(true);
      } finally {
        setLoading(false);
      }
    }

    if (selectedTab === "WHATSAPP") {
      try {
        setLoading(true);
        const response = await services.Whatsapp.WHATSAPP_SEARCH_CONTACT(selectedProfileId, searchedVal);

        const allFreshContacts = response?.data?.data?.Contacts || [];
        setAllWhatsappData(allFreshContacts)

        setNoMailFound(allFreshContacts.length === 0);
      } catch (err) {
        setAllWhatsappData([]);
        setNoMailFound(true);
      } finally {
        setLoading(false);
      }
    }
  };


  const cancelSearch = () => {
    setSearched("");
    if (selectedTab === "GMAIL" && selectedEmailsIds.length > 0) {
      getAllInboxMailFilter(1);
    } else if (selectedTab === "WHATSAPP") {
      if (selectedProfileId) {
        GET_CONTACT_WHATSAPP(page, selectedProfileId);
      } else {
        setAllWhatsappData([]);
      }
    } else {
      setInboxFilterMailData([]);
      setAllWhatsappData([]);
    }
    setNoMailFound(false);
  };

  useEffect(() => {
    setActiveButton(Action);
  }, [Action])
  useEffect(() => {
    if (selectedTab === "GMAIL" || selectedTab === 'GMAIL_BOARD') {
      setActiveButton("board")
    }
  }, [selectedTab])

  const handleProfileChange = (id) => {
    setSelectedProfileId(id);

    const selectedProfile = allWhatsaapUserProfile?.find(
      (item) => item?.id === id
    );

    if (selectedProfile) {
      setSessionId(selectedProfile?.clientId);
      GET_CONTACT_WHATSAPP(page, selectedProfile?.id);
    }
  };

  const getAllBoard = async () => {
    try {
      const { data } = await services.board.GETALLBOARD();
      const mapData =
        data?.length > 0 &&
        data?.map(({ boardName, id }) => ({ label: boardName, value: id }));

      let newlyAddedBoard = null;
      if (boardName.length > 0 && mapData.length > boardName.length) {
        const oldBoardIds = new Set(boardName.map((b) => b.value));
        newlyAddedBoard = mapData.find((b) => !oldBoardIds.has(b.value));
      }

      setBoardName(mapData);

      if (newlyAddedBoard) {
        setSelectedBoard(newlyAddedBoard);
        setSelectedBoardId(newlyAddedBoard.value);
        handleSelectedBoard(newlyAddedBoard);
        return;
      }

      if (mapData?.length > 0) {
        const savedBoard = getLocalStorageItem("board");
        if (savedBoard) {
          try {
            const parsedBoard = savedBoard;
            const boardExists = mapData.some(
              (b) => b.value === parsedBoard.value
            );
            if (boardExists) {
              if (!selectedBoardId || selectedBoardId !== parsedBoard.value) {
                setSelectedBoard(parsedBoard);
                setSelectedBoardId(parsedBoard.value);
                handleSelectedBoard(parsedBoard);
              }
            } else {
              if (
                !selectedBoardId ||
                !mapData.some((b) => b.value === selectedBoardId)
              ) {
                setSelectedBoard(mapData[0]);
                setSelectedBoardId(mapData[0].value);
                handleSelectedBoard(mapData[0]);
              }
            }
          } catch (error) {
            console.error("Error parsing saved board:", error);
            if (
              !selectedBoardId ||
              !mapData.some((b) => b.value === selectedBoardId)
            ) {
              setSelectedBoard(mapData[0]);
              setSelectedBoardId(mapData[0].value);
              handleSelectedBoard(mapData[0]);
            }
          }
        } else {
          if (
            !selectedBoardId ||
            !mapData.some((b) => b.value === selectedBoardId)
          ) {
            setSelectedBoard(mapData[0]);
            setSelectedBoardId(mapData[0].value);
            handleSelectedBoard(mapData[0]);
          }
        }
      } else {
        setBoardName([]);
        setSelectedBoard(null);
        setSelectedBoardId(null);
        handleSelectedBoard(null);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setBoardLoading(false);
      setIsBoardFetched(true);
    }
  };

  const getBoardColumnById = async () => {
    try {
      const response = await services.userassignboard.GET_UserAssignBoard_ID(
        UserId
      );
      const assignedBoards = response?.data?.data || [];
      const boardOptions =
        assignedBoards?.length > 0 &&
        assignedBoards.map((assigned) => ({
          label: assigned.Board.boardName,
          value: assigned.Board.id,
          boardListId: assigned.boardListId,
          BoardLists: assigned.Board.BoardLists,
        }));
      setBoardName(boardOptions);
      let selected = null;
      const savedBoard = getLocalStorageItem("board");
      if (savedBoard) {
        try {
          const parsed = savedBoard;
          selected =
            boardOptions.find((b) => b.value === parsed.value) ||
            boardOptions[0];
        } catch {
          selected = boardOptions[0];
        }
      } else {
        selected = boardOptions[0];
      }
      setSelectedBoard(selected);
      setSelectedBoardId(selected?.value);
      setLocalStorageItem("board", selected);

      if (!selected?.value) {
        setColumns([]);
        dispatch(addColumnsDetails([]));
        removeLocalStorageItem("columns");
        return;
      }

      // Call SELECTED_BOARD to get all columns in admin-defined sequence order
      const boardResp = await services.board.SELECTED_BOARD(selected.value);
      const allBoardColumns = boardResp?.data || [];

      // Find the assigned board to know which columns this user can see
      const assignedBoard = assignedBoards.find(
        (b) => b.Board.id === selected.value
      );
      const assignedBoardListId = assignedBoard?.boardListId || [];
      const hasWildcard = assignedBoardListId.some((col) => col.id === "*" || col.value === "*");
      const assignedIds = new Set(
        assignedBoardListId.map((col) => col.value || col.id)
      );
      const showAll = hasWildcard || assignedIds.size === 0;

      const columnsData = allBoardColumns
        .slice()
        .sort((a, b) => Number(a.sequence) - Number(b.sequence))
        .filter((col) => showAll || assignedIds.has(col.id))
        .map((col) => ({
          id: col.id,
          title: col.coloum || col.label,
          className: col.colour || "#00F767",
          borderColor: col.colour || "#00F767",
          sequence: col.sequence,
        }));

      setColumns(columnsData);
      dispatch(addColumnsDetails(columnsData));
      if (selected?.value) {
        dispatch(getAllDateTableTask({ data: { boardId: selected.value } }));
      }
    } catch (e) {
      console.error(e);
    } finally {
      setBoardLoading(false);
      setIsBoardFetched(true);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (role && !isBoardFetched && !boardLoading && token) {
      setBoardLoading(true);
      if (role === "User") {
        getBoardColumnById();
      } else {
        getAllBoard();
      }
    }
  }, [role, isBoardFetched, boardLoading]);

  useEffect(() => {
    const handleAuthMessage = (event) => {
      if (event.data?.token && role && !isBoardFetched && !boardLoading) {
        setBoardLoading(true);
        if (role === "User") {
          getBoardColumnById();
        } else {
          getAllBoard();
        }
      }
    };

    window.addEventListener("message", handleAuthMessage);
    return () => window.removeEventListener("message", handleAuthMessage);
  }, [role, isBoardFetched, boardLoading]);
  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (token && selectedBoardId && (activeButton === "board" || activeButton === "table")) {
      getTaskMail(1, {}, selectedBoardId);
    }
  }, [selectedBoardId, activeButton, filters]);

  const getCurrentBoardId = () => {
    if (selectedBoardId) {
      return selectedBoardId;
    }

    const savedBoard = getLocalStorageItem("board");
    const savedBoardId = getLocalStorageItem("boardId");

    if (savedBoard) {
      return typeof savedBoard === "object" ? savedBoard.value : savedBoard;
    } else if (savedBoardId) {
      return savedBoardId;
    }

    return null;
  };

  useEffect(() => {
    getAllAutomation()
  }, [selectedBoardId])

  const handleLabelClick = async (item) => {
    let response = null;
    if (item?.isTaskCreated == true) {
      response = await services.email.GET_TASK_GMAILMESSAGE_ID(
        item?.gmailMessageId
      );
    }
    navigate(`/detail/${item?.id}`, {
      state: {
        selectedMail: item,
        activeButton: activeButton,
        taskID: item?.isTaskCreated == true ? response?.data.id : null,

        labelType: "Label",
        selectedLabelId: selectedLabelId,
        currentTask: item?.isTaskCreated == true ? response?.data : null,
        boardId: selectedBoardId,
        boardName: boardName,
        lastExpandedId: lastExpandedId,
      },
    });
  };

  function markPath(node, id) {
    if (!node) return [node, false];

    if (node.id === id) {
      return [{ ...node, expanded: true }, true];
    }

    if (node.children) {
      let found = false;
      const newChildren = node.children.map((child) => {
        const [newChild, childFound] = markPath(child, id);
        if (childFound) found = true;
        return newChild;
      });

      if (found) {
        return [{ ...node, children: newChildren, expanded: true }, true];
      } else {
        return [{ ...node, children: newChildren }, false];
      }
    }

    return [node, false];
  }

  function expandPathToId(id) {
    if (!id) return;
    setNode((prev) => {
      const [newNode] = markPath(prev, id);
      return newNode;
    });
  }

  const moveTaskAction = async (taskId, toColumnId, toIndex, updatedTasks, isDifferentColumn = false) => {
    // 1. If moved to a different column, update the task's boardListId first (as requested)
    if (isDifferentColumn) {
      try {
        await services.task.UPDATE_TASK(taskId, { boardListId: toColumnId });
      } catch (error) {
        console.error("❌ Error updating task column:", error);
      }
    }

    // 2. Then update the sequence/display order (Always called)
    let beforeTaskId = null;
    let afterTaskId = null;

    if (toIndex === 0) {
      beforeTaskId = updatedTasks[1]?.id || null;
    } else if (toIndex === updatedTasks.length - 1) {
      afterTaskId = updatedTasks[updatedTasks.length - 2]?.id || null;
    } else {
      afterTaskId = updatedTasks[toIndex - 1]?.id || null;
      beforeTaskId = updatedTasks[toIndex + 1]?.id || null;
    }

    const payload = {
      taskId: taskId,
      beforeTaskId,
      afterTaskId,
      boardListId: toColumnId,
    };

    try {
      await services.task?.MOVE_TASK_DRAG_DROP(payload);
    } catch (error) {
      console.error("❌ Error in moveTaskAction:", error);
    }
  };

  const createTaskFromInbox = async (item, toColumnId, toIndex, extraData = {}, sourceDroppableId) => {
    let targetBoardListId = toColumnId;

    if (toColumnId && (toColumnId.startsWith("date-view-") || toColumnId === "table-view" || toColumnId === "date-view")) {
      const defaultColumn = columns.find(c => c.sequence === 1) || columns[0];
      if (defaultColumn) {
        targetBoardListId = defaultColumn.id;
      } else {
        console.error("No default column found");
        return;
      }
    }

    const dataObj = {


      boardListId: targetBoardListId,
      title: item?.subEmail?.subject || item.subject || item.title || "",
      taskType: selectedTab === 'GMAIL' || selectedTab === 'GMAIL_BOARD' ? 'Gmail' : 'Whatsapp',
      // Determine boardId based on drop target if possible, otherwise use localSt
      boardId: localSt?.value || selectedBoardId,
      gmailMessageId: item.gmailMessageId || undefined,
      contactId: selectedTab === 'WHATSAPP' || selectedTab === 'WHATSAPP_BOARD' ? item.id : undefined,
      ...(role === "User" ? { userId: userId } : {}),
      ...extraData,
    };

    try {
      const response = await services.task.CREATE_TASK(dataObj);
      if (response) {
        // 1. Remove from Source List State
        if (sourceDroppableId === "inbox") {
          setInboxFilterMailData(prev => prev.filter(mail => mail.id !== item.id));
        } else if (sourceDroppableId === "whatsapp-inbox") {
          setAllWhatsappData(prev => prev.filter(contact => contact.id !== item.id));
        } else if (sourceDroppableId === "board-inbox") {
          // Assuming combinedArray is derived or managed elsewhere, but if it was state:
          // setCombinedArray(prev => prev.filter(i => i.id !== item.id));
          // Since combinedArray variable definition isn't fully visible/editable here easily, 
          // we focus on the primary inbox states requested.
          // If combinedArray is derived from inboxFilterMailData, updating that might be enough.
          setInboxFilterMailData(prev => prev.filter(mail => mail.id !== item.id));
        }

        const newTaskId = response.data?.data?.id;

        // 2. Refresh tasks to get the new task in the list
        if (selectedBoardId) {
          await getTaskMail(1, {}, selectedBoardId);
        }

        // Explicitly call updateTask as requested, even if redundant for a new task
        if (newTaskId) {
          try {
            await services.task.UPDATE_TASK(newTaskId, { boardListId: targetBoardListId });
          } catch (e) {
            console.error("Error calling updateTask on create:", e);
          }
        }

        // 2b. If we dropped into Date View, we MUST refresh the Date Table data
        if (targetBoardListId && (toColumnId?.startsWith("date-view-") || toColumnId === "date-view")) {
          try {
            dispatch(getAllDateTableTask({ data: { boardId: dataObj.boardId } }));
          } catch (e) {
            console.error("Error dispatching getAllDateTableTask:", e);
          }
        }

        // 3. Move Task to Correct Index if needed
        // If we just created it, it's likely at the top or bottom. We need to move it to 'toIndex'.
        if (newTaskId && typeof toIndex === 'number' && targetBoardListId) {
          // We need to fetch the latest state or use what we have. 
          // faster to just trigger the move with the assumption that getTaskMail updated `taskMail` state?
          // `taskMail` state update might be async and not ready yet. 
          // However, getTaskMail follows a setTaskMail.
          // Let's call moveTaskAction which handles reordering. 
          // But moveTaskAction needs the array of tasks.

          // Construct a temporary updated tasks array for the move logic
          const currentTasks = taskMail[targetBoardListId] || [];
          // Note: currentTasks might not have the new task yet if state hasn't flushed. 
          // But since we awaited getTaskMail, we hope. 
          // If not, we can try to do it optimistically.

          // Let's assume the new task is effectively "at the end" or "at the start" (default create behavior).
          // If we can't find it in currentTasks, we append it.
          let updatedTasks = [...currentTasks];
          const createdTask = response.data.data;

          const existingIdx = updatedTasks.findIndex(t => t.id === newTaskId);
          if (existingIdx !== -1) {
            updatedTasks.splice(existingIdx, 1);
          }
          updatedTasks.splice(toIndex, 0, createdTask);

          await moveTaskAction(newTaskId, targetBoardListId, toIndex, updatedTasks);

          // Final Refresh to sync everything
          getTaskMail(1, {}, selectedBoardId);
        }
        return response;
      }
    } catch (error) {
      console.error("Error creating task from inbox:", error);
    }
  };

  const onDragEnd = async (result) => {
    const { destination, source, draggableId, type, combine } = result;

    // Handle combine (Dropping a task onto another task to create a child task)
    if (combine) {
      const sourceColumnId = source.droppableId;
      const targetTaskIds = combine.draggableId; // The task ID being dropped ONTO
      const draggedTaskId = draggableId;         // The task ID being dragged

      // Call API to update child task relationship
      try {
        let childId = draggedTaskId;

        // If dragging from inbox, we must create the task first
        if (sourceColumnId === "inbox" || sourceColumnId === "board-inbox" || sourceColumnId === "whatsapp-inbox") {
          const item = sourceColumnId === "inbox"
            ? inboxFilterMailData[source.index]
            : sourceColumnId === "board-inbox"
              ? combinedArray[source.index]
              : allWhatsappData[source.index];

          if (item) {
            // Create the task first. We need to find which column the target task belongs to.
            // But for a child task, we can just use the first column or any valid columnId
            // since it will be linked to a parent anyway.
            const response = await createTaskFromInbox(item, null, null, {}, sourceColumnId);
            if (response?.data?.data?.id) {
              childId = response.data.data.id;
            } else {
              throw new Error("Failed to create task from inbox for combine");
            }
          }
        }

        await services.task.UPDATE_CHILD_TASK(targetTaskIds, {
          parentTaskID: targetTaskIds,
          parentTaskStatus: true,
          taskId: childId
        });

        // Refresh tasks to reflect the change
        if (selectedBoardId) {
          getTaskMail(1, {}, selectedBoardId);
        }
      } catch (error) {
        console.error("Error creating child task:", error);
      }
      return;
    }

    if (!destination) {
      return;
    }

    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return;
    }

    // Handle column reordering
    if (type === "COLUMN") {
      const fromIndex = source.index;
      const toIndex = destination.index;

      const updatedColumns = [...columns];
      const [movedColumn] = updatedColumns.splice(fromIndex, 1);
      updatedColumns.splice(toIndex, 0, movedColumn);

      setColumns(updatedColumns);

      // Also update Redux to keep everything in sync
      dispatch(addColumnsDetails(updatedColumns));

      const sequenceData = updatedColumns.map((col, index) => ({
        id: col.id,
        sequence: index + 1,
      }));

      services.board
        .SEQUENCE(sequenceData, selectedBoardId)
        .catch((e) => console.error("Sequence update error:", e));
      return;
    }

    // Handle task movement
    const sourceDroppableId = source.droppableId;
    const destinationDroppableId = destination.droppableId;

    // Case 1: From Inbox to Board
    if (sourceDroppableId === "inbox" || sourceDroppableId === "board-inbox" || sourceDroppableId === "whatsapp-inbox") {
      const item = sourceDroppableId === "inbox"
        ? inboxFilterMailData[source.index]
        : sourceDroppableId === "board-inbox"
          ? combinedArray[source.index]
          : allWhatsappData[source.index];

      if (!item) return;

      if (destinationDroppableId.startsWith("date-view-")) {
        const dateStr = destinationDroppableId.replace("date-view-", "");
        const formattedDate = moment(dateStr).format('MMM DD');
        await createTaskFromInbox(item, destinationDroppableId, destination.index, { myDayPlan: formattedDate }, sourceDroppableId);
      } else {
        await createTaskFromInbox(item, destinationDroppableId, destination.index, {}, sourceDroppableId);
      }
      return;
    }

    // Case 2: Within Board (same or different column)
    if (destinationDroppableId !== "inbox" && destinationDroppableId !== "board-inbox") {
      const sourceTasks = taskMail[sourceDroppableId] || [];
      const movedTask = sourceTasks[source.index];

      if (!movedTask) return;

      if (sourceDroppableId === destinationDroppableId) {
        // Reordering within the same column
        const updatedTasks = [...sourceTasks];
        updatedTasks.splice(source.index, 1);
        updatedTasks.splice(destination.index, 0, movedTask);

        setTaskMail((prev) => ({
          ...prev,
          [sourceDroppableId]: updatedTasks,
        }));

        moveTaskAction(draggableId, sourceDroppableId, destination.index, updatedTasks);
      } else {
        // Moving to another column
        const targetTasks = taskMail[destinationDroppableId] || [];
        const newSourceTasks = [...sourceTasks];
        newSourceTasks.splice(source.index, 1);
        const newTargetTasks = [...targetTasks];
        newTargetTasks.splice(destination.index, 0, movedTask);

        setTaskMail((prev) => ({
          ...prev,
          [sourceDroppableId]: newSourceTasks,
          [destinationDroppableId]: newTargetTasks,
        }));

        // Explicitly update the task's column immediately
        try {
          await services.task.UPDATE_TASK(draggableId, { boardListId: destinationDroppableId });
        } catch (error) {
          console.error("Error updating task column:", error);
        }

        moveTaskAction(draggableId, destinationDroppableId, destination.index, newTargetTasks, true);
      }
    }
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>

      <PermissionContext.Provider value={{ permissions }}>
        <div className="h-full overflow-hidden">
          <Header
            filters={filters}
            setFilters={setFilters}
            columns={columns}
            filterList={filterList}
            emailName={emailName}
            handleChange={handleChange}
            handleSelectedBoard={handleSelectedBoard}
            setSelectedBoardId={setSelectedBoardId}
            handleAddColumn={handleAddColumn}
            selectedBoardId={selectedBoardId}
            selectedEmailsIds={selectedEmailsIds}
            role={role}
            setSelectedBoard={setSelectedBoard}
            selectedBoard={selectedBoard}
            getTaskMailIndbox={getAllInboxMailFilter}
            getAllBoard={getAllBoard}
            boardName={boardName}
            setBoardName={setBoardName}
            getTaskMail={getTaskMail}
            activeButton={activeButton}
            setActiveButton={setActiveButton}
            setTaskMail={setTaskMail}
            fetchAllData={fetchAllData}
            userList={userList}
          />
          {role != "User" || showGmailTab || showWhatsappTab ? (
            <div
              className={`border-2 ${activeButton === 'sent' || activeButton === 'all-mail' ? 'grid grid-cols-1' : 'grid grid-cols-[27%_auto]'
                }`}
              style={activeButton === 'sent' || activeButton === 'all-mail' ? { width: '100%' } : {}}
            >
              {activeButton !== 'sent' && activeButton !== 'all-mail' && (
                <div className="overflow-y-auto overflow-x-auto" style={{ maxHeight: '90vh' }}>
                  <div
                    style={{
                      marginTop: "3px",
                    }}
                  >
                    {activeButton !== 'sent' && activeButton !== "label" &&
                      selectedTab !== "GMAIL_BOARD" && (
                        <div style={{ position: "relative", width: "100%" }}>
                          <input
                            type="text"
                            value={searched}
                            onChange={(e) => setSearched(e.target.value)}
                            className="request-search"
                          />
                          {searched && (
                            <button
                              onClick={() => cancelSearch()}
                              className="cancel-search"
                              aria-label="Clear search"
                            >
                              ×
                            </button>
                          )}
                        </div>
                      )}
                  </div>
                  {activeButton !== 'sent' && activeButton !== "label" &&
                    selectedTab === "GMAIL" &&
                    filterList &&
                    (role !== "User" || showGmailTab) && (
                      <div className="drop-header">
                        <MultiSelect

                          className="gmail-scroll"
                          options={filterList}
                          value={selectedEmailsIds}
                          onChange={handleChange}
                          labelledBy="Select Emails"
                        />
                      </div>
                    )}

                  {activeButton === "label" && (
                    <div className="p-2">
                      <CreateLabelDialog
                        open={openLabelDialog}
                        setOpen={setOpenLabelDialog}
                        fetchAllData={fetchAllData}
                        labelId={selectedLabelId}
                      />
                      <DeleteLabelDialog
                        open={openDeleteDialog}
                        setOpen={setOpenDeleteDialog}
                        labelId={deleteLabelId}
                        onDeleted={() => {
                          fetchAllData();
                        }}
                      />
                      <ul role="tree">
                        {node.children?.map((child) => renderNode(child, 0))}
                      </ul>
                    </div>
                  )}
                  {activeButton !== 'sent' && activeButton !== "label" && selectedTab == "WHATSAPP" && (
                    <div className="flex justify-between px-2.5 mt-6 items-center mb-[10px] border-b-2">
                      <div className="flex gap-3 items-center">
                        <div
                          className={`flex gap-1.5 cursor-pointer ${getColorWhatsapp(
                            "allWhatsappChat"
                          )}`}
                          onClick={() => setSelectedWhatspp("allWhatsappChat")}
                        >
                          <img src="./assets/primary.svg" alt="All" />
                          <span>All</span>
                        </div>
                        <div
                          className={`flex gap-1.5 cursor-pointer ${getColorWhatsapp(
                            "groupWhatsappChat"
                          )}`}
                          onClick={() =>
                            setSelectedWhatspp("groupWhatsappChat")
                          }
                        >
                          <img src="./assets/primary.svg" alt="Group" />
                          <span>Group</span>
                        </div>

                        <div className="flex gap-1.5 cursor-pointer items-center">
                          <select
                            className="border border-gray-300 rounded px-2 py-0.5 text-sm"
                            style={{ marginLeft: "12px", width: "80%" }}
                            value={selectedProfileId}
                            onChange={(e) =>
                              handleProfileChange(e.target.value)
                            }
                          >
                            {allWhatsaapUserProfile &&
                              allWhatsaapUserProfile?.length > 0 &&
                              allWhatsaapUserProfile?.map((item) => (
                                <option key={item?.id} value={item?.id}>
                                  {item?.name}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  )}
                  {activeButton !== 'sent' && activeButton !== "label" &&
                    selectedTab === "GMAIL_BOARD" && (
                      <div className="mt-2 gmail-board-tab">
                        {(() => {
                          const options = boardName ? [...boardName] : [];

                          return (
                            <Select
                              className="cursor-pointer"
                              style={{ width: "150px" }}
                              options={options}
                              value={selectedBoard}
                              isMulti={false}
                              onChange={(e) => {
                                setSelectedBoardId(e?.value);
                                setLocalStorageItem("boardId", e?.value);
                                handleSelectedBoard(e);
                                setSelectedBoard(e);
                                setBoardName((prev) => {
                                  const rest = prev.filter(
                                    (b) => b.value !== e.value
                                  );
                                  return [e, ...rest];
                                });
                              }}
                              components={{
                                Option: ({ data, innerRef, innerProps }) => (
                                  <div
                                    ref={innerRef}
                                    {...innerProps}
                                    className="label-board"
                                  >
                                    <span
                                      className="label-span"
                                      title={data.label}
                                    >
                                      {data.label}
                                    </span>
                                  </div>
                                ),
                              }}
                            />
                          );
                        })()}
                      </div>
                    )}


                  {activeButton !== 'sent' && activeButton !== "label" && selectedTab === "GMAIL" && (
                    <div onScroll={handleScroll} className="inbox-Mail">
                      {generateMailInbox()}
                    </div>
                  )}


                  {activeButton !== 'sent' &&
                    activeButton !== "label" &&
                    selectedTab === "WHATSAPP" && (
                      <div className="sidebar-container">
                        <div
                          className="inbox-Mail"
                          ref={sidebarRef}
                          onScroll={handleScrollWhatsapp}
                        >
                          {generateWhatsAppInbox()}

                          {loading && <p>Loading more items...</p>}

                          {noMailFound && searched && (
                            <div className="whatsapp-no-result">
                              <p>No contacts found for "{searched}".</p>
                              <button
                                className="add-contact-btn mt-3"
                                onClick={() => {
                                  if (!selectedProfileId) {
                                    toast.error("Please select a profile first!");
                                    return;
                                  }
                                  setShowAddContactModal(true)

                                }}
                              >
                                Add contact "{searched}"
                              </button>
                            </div>
                          )}
                        </div>
                        <AddContactModal
                          showModal={showAddContactModal}
                          handleClose={() => setShowAddContactModal(false)}
                          sessionId={sessionId}
                          onContactAdded={handleContactAdded}
                          searched={searched}
                        />
                      </div>
                    )}
                  {activeButton !== 'sent' && activeButton !== "label" &&
                    selectedTab === "GMAIL_BOARD" && (
                      <div onScroll={handleScroll} className="inbox-Mail">
                        {generateMailBoard()}
                      </div>
                    )}
                </div>
              )}

              {activeButton !== 'sent' && activeButton !== 'all-mail' && activeButton !== "label" && activeButton !== "" && (
                <TaskContext.Provider
                  value={{
                    tasks,
                    setTasks,
                    updateTitleInLocalStorage,
                    isModalOpen,
                    handleCloseModal,
                    getTaskMailIndbox,
                    updateDeadlineDateInLocalStorage,
                    moduleName,
                  }}
                >
                  <ColumnContext.Provider
                    value={{
                      columns,
                      setColumns,
                      addTaskToColumn,
                      updateColunTitleInLocalStorage,
                      updateDeadlineDateInLocalStorage,
                      moveTaskUp,
                      moveTaskDown,
                      isModalOpen,
                      handleCloseModal,
                      getTaskMailIndbox,
                      handleAddColumn,
                      columnAddStatus,
                      setColumnAddStatus,
                      filterList,
                      handleUpdateTask,
                      selectedBoardId,
                      setSelectedBoardId,
                      moveColumn,
                      taskMail,
                      setTaskMail,
                      getTaskMail,
                      setSortBy,
                      setSortOrder,
                      sortby,
                      sortOrder,
                      getAllBoard,
                      activeButton,
                      allCustomFieldList,
                      setAllCustomFieldList,
                      getAllAutomation,
                      userList: allUsers
                    }}
                  >
                    <div className="overflow-x-auto overflow-y-auto h-[100vh] relative">
                      <Board
                        isMember={isMember}
                        parentOrigin={parentOrigin}
                        isModalOpen={isModalOpen}
                        onClose={handleCloseModal}
                        boardName={boardName}
                        filterList={filterList}
                      />
                    </div>
                  </ColumnContext.Provider>
                </TaskContext.Provider>
              )}

              {activeButton !== 'sent' && activeButton !== 'all-mail' && selectedTab === "WHATSAPP" && selectedWhatsappItem && (
                <ChatWhatsapp selectedWhatsappItem={selectedWhatsappItem} sessionId={sessionId} allData={allData} />
              )}

              {activeButton !== 'sent' && activeButton !== 'all-mail' && selecteType === "label-root" && (
                <div className="w-full bg-gray-50 p-2 rounded-lg">
                  <ul role="list" className="space-y-2">
                    {emails.length > 0 ? (
                      emails.map((m) => (
                        <li
                          key={m.id}
                          onClick={() => handleLabelClick(m)}
                          className="cursor-pointer bg-white border border-gray-200 rounded-md shadow-sm hover:shadow-md hover:bg-blue-50 transition-all duration-200"
                        >
                          <div className="flex items-center px-4 py-3 overflow-hidden">
                            <div className="w-48 truncate font-semibold text-gray-900 text-sm flex-shrink-0">
                              {m.name || m.title}
                            </div>

                            <div className="flex-1 min-w-0 truncate text-sm text-gray-700 ml-4">
                              <span className="font-medium text-gray-900">
                                {m.subject || "Manual Task"}
                              </span>
                              <span
                                className="text-gray-500 ml-1"
                                dangerouslySetInnerHTML={{
                                  __html:
                                    (m.body?.replace(/<[^>]+>/g, "").slice(0, 100) || "") +
                                    "...",
                                }}
                              />
                            </div>

                            <div className="ml-4 text-xs text-gray-500 flex-shrink-0">
                              {new Date(m.createdAtEmail || m.createdAt).toLocaleDateString(
                                "en-US",
                                { month: "short", day: "numeric", year: "numeric" }
                              )}
                            </div>
                          </div>
                        </li>
                      ))
                    ) : (
                      <li className="p-4 text-center text-sm text-gray-400">
                        No emails found for this label.
                      </li>
                    )}
                  </ul>


                  {pagination && pagination.totalPages > 1 && (
                    <div className="flex items-center justify-center mt-4 space-x-2">
                      <button
                        onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                        disabled={currentPage === 1}
                        className={`px-3 py-1 text-sm border rounded-md ${currentPage === 1
                          ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                          : "bg-white hover:bg-blue-50"
                          }`}
                      >
                        Prev
                      </button>

                      {Array.from({ length: pagination.totalPages }, (_, i) => i + 1)
                        .slice(
                          Math.max(0, currentPage - 3),
                          Math.min(pagination.totalPages, currentPage + 2)
                        )
                        .map((page) => (
                          <button
                            key={page}
                            onClick={() => setCurrentPage(page)}
                            className={`px-3 py-1 text-sm border rounded-md ${currentPage === page
                              ? "bg-blue-500 text-white"
                              : "bg-white hover:bg-blue-50"
                              }`}
                          >
                            {page}
                          </button>
                        ))}

                      <button
                        onClick={() =>
                          setCurrentPage((p) => Math.min(p + 1, pagination.totalPages))
                        }
                        disabled={currentPage === pagination.totalPages}
                        className={`px-3 py-1 text-sm border rounded-md ${currentPage === pagination.totalPages
                          ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                          : "bg-white hover:bg-blue-50"
                          }`}
                      >
                        Next
                      </button>
                    </div>
                  )}


                </div>
              )}

              {activeButton !== 'sent' && activeButton !== 'all-mail' && selecteType === "kanban-root" && (

                <div
                  ref={listRef}
                  className="w-full bg-gray-50 p-2 rounded-lg"
                  style={{
                    height: "70vh",
                    overflowY: "auto",
                    display: "block",
                  }}
                >
                  <ul role="list" className="space-y-2">
                    {emails.length > 0 ? (
                      emails.map((m) => (
                        <li
                          key={m.id}
                          onClick={() => handleLabelClick(m)}
                          className="cursor-pointer bg-white border border-gray-200 rounded-md shadow-sm hover:shadow-md hover:bg-blue-50 transition-all duration-200"
                        >
                          <div className="flex items-center px-4 py-3 overflow-hidden">
                            <div className="w-48 truncate font-semibold text-gray-900 text-sm flex-shrink-0">
                              {m.name || m.title}
                            </div>

                            <div className="flex-1 min-w-0 truncate text-sm text-gray-700 ml-4">
                              <span className="font-medium text-gray-900">
                                {m.subject || "Manual Task"}
                              </span>
                              <span
                                className="text-gray-500 ml-1"
                                dangerouslySetInnerHTML={{
                                  __html:
                                    (m.body?.replace(/<[^>]+>/g, "").slice(0, 100) || "") + "...",
                                }}
                              />
                            </div>

                            <div className="ml-4 text-xs text-gray-500 flex-shrink-0">
                              {new Date(m.createdAtEmail || m.createdAt).toLocaleDateString(
                                "en-US",
                                { month: "short", day: "numeric", year: "numeric" }
                              )}
                            </div>
                          </div>
                        </li>
                      ))
                    ) : (
                      <li className="p-4 text-center text-sm text-gray-400">
                        No emails found for this label.
                      </li>
                    )}
                  </ul>

                  {taskPagination.currentPage < taskPagination.totalPages && (
                    <div className="text-center py-3 text-sm text-gray-500">
                      Loading more tasks...
                    </div>
                  )}
                </div>
              )}


              {activeButton === "sent" && (
                <div className="w-full bg-gray-50 p-2 rounded-lg">
                  <ul role="list" className="space-y-2 h-[80vh] overflow-y-auto">
                    {sentEmails.length > 0 ? (
                      sentEmails.map((m) => (
                        <li
                          key={m.id}
                          onClick={() => handleLabelClick(m)}
                          className="cursor-pointer bg-white border border-gray-200 rounded-md shadow-sm hover:shadow-md hover:bg-blue-50 transition-all duration-200"
                        >
                          <div className="flex items-center px-4 py-3 "

                          >
                            <div className="w-48 truncate font-semibold text-gray-900 text-sm flex-shrink-0">
                              {m.name || m.sentBy}
                            </div>

                            <div className="flex-1 min-w-0 truncate text-sm text-gray-700 ml-4">
                              <span className="font-medium text-gray-900">
                                {m.subject || "(No subject)"}
                              </span>
                              <span
                                className="text-gray-500 ml-1"
                                dangerouslySetInnerHTML={{
                                  __html:
                                    (m.body?.replace(/<[^>]+>/g, "").slice(0, 500) || "") +
                                    "...",
                                }}
                              />
                            </div>

                            <div className="ml-4 text-xs text-gray-500 flex-shrink-0">
                              {new Date(m.createdAtEmail || m.createdAt).toLocaleDateString(
                                "en-US",
                                {
                                  month: "short",
                                  day: "numeric",
                                  year: "numeric",
                                }
                              )}
                            </div>
                          </div>
                        </li>
                      ))
                    ) : (
                      <li className="p-4 text-center text-sm text-gray-400">
                        No emails found for this label.
                      </li>
                    )}
                  </ul>

                  <div style={{ marginTop: "20px" }}>
                    <ResponsivePagination
                      current={mailPage}
                      total={totalCount}
                      onPageChange={setMailPage}
                    />
                  </div>
                </div>

              )}

              {activeButton === "all-mail" && (
                <div className="w-full bg-gray-50 p-2 rounded-lg">
                  <ShowAllMail gmailUsers={filterList} ActionPage={ActionPage} />
                </div>
              )}


            </div>
          ) : (
            <>
              {(boardName && boardName.length > 0 && selectedBoard) ? (
                <div
                  style={role == "User" ? { marginLeft: "20px" } : {}}
                  className="border-r border-r-solid border-r-gray-400 w-full"
                >
                  <TaskContext.Provider
                    value={{ tasks, setTasks, updateTitleInLocalStorage }}
                  >
                    <ColumnContext.Provider
                      value={{
                        columns,
                        setColumns,
                        addTaskToColumn,
                        updateColunTitleInLocalStorage,
                        updateDeadlineDateInLocalStorage,
                        moveTaskUp,
                        moveTaskDown,
                        handleAddColumn,
                        getTaskMailIndbox,
                        columnAddStatus,
                        setColumnAddStatus,
                        filterList,
                        handleUpdateTask,
                        selectedBoardId,
                        moveColumn,
                        taskMail,
                        setTaskMail,
                        getTaskMail,
                        getAllBoard,
                      }}
                    >
                      <Board
                        moduleName={moduleName}
                        boardName={boardName}
                        filterList={filterList}
                      />
                    </ColumnContext.Provider>
                  </TaskContext.Provider>
                </div>
              ) : (null)}
            </>
          )}
        </div>
        {whatsAppStatus && (
          <WhatsAppAuth
            whatsAppStatus={whatsAppStatus}
            onClose={() => dispatch(setWhatsAppStatus(false))}
          />
        )}
        {emailStatus && (
          <EmailAuth
            emailStatus={emailStatus}
            onClose={() => dispatch(setEmailStatus(false))}
          />
        )}
      </PermissionContext.Provider>

    </DragDropContext>

  );
};

export default AppViewer;
